export default __webpack_public_path__ + "static/media/nossas_unidades_9.074f1e00.webp";